import AppConfig from "config/AppConfig";
import * as Yup from "yup";

const { PATTERNS } = AppConfig;

export const required = value => (value ? undefined : "required");

export const positiveNumberMoreThan1 = value => {
  return (value < 1) ? "moreThanZero" : undefined;
};

export const password = value => {
  if (!PATTERNS.PASSWORD_PATTERN.test(value)) {
    return "minLength";
  } else if (!PATTERNS.PASSWORD_UPPER.test(value)) {
    return "uppercase";
  } else if (!PATTERNS.PASSWORD_LOWER.test(value)) {
    return "lowercase";
  } else if (!PATTERNS.PASSWORD_NUMBER.test(value)) {
    return "number";
  }
  return undefined;
};

export const fileSize = imageFile => {
  if (imageFile && imageFile.size) {
    // Get image size in kilobytes
    const imageFileKb = imageFile.size / 1024;
    const maxSize = 2048;
    if (imageFileKb > maxSize) {
      return "maxSize";
    }
  }
};

export const confirmPassword = (value, { newPassword, password }) => {
  if (newPassword) {
    return value !== newPassword ? "mismatch" : undefined;
  } else {
    return value !== password ? "mismatch" : undefined;
  }
};

export const endDate = (endDate, { startDate }) => !startDate || !endDate ? undefined : new Date(endDate) > new Date(startDate) ? undefined : "invalid";

export const YupValidations = {
  requiredString: Yup.string()
    .trim()
    .required("validation.required")
    .max(240, "validation.max_length_240")
    .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
  password: Yup.string()
    .required("validation.required")
    .matches(PATTERNS.PASSWORD_PATTERN, {
      message: "validation.password.minLength"
    })
    .max(32, "validation.max_length_32")
    .matches(PATTERNS.PASSWORD_UPPER, {
      message: "validation.password.uppercase"
    })
    .matches(PATTERNS.PASSWORD_LOWER, {
      message: "validation.password.lowercase"
    })
    .matches(PATTERNS.PASSWORD_NUMBER, {
      message: "validation.password.number"
    })
    .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
    .test('password', 'validation.password.spaces', (value) => {
      if (value && value.includes(' ')) {
          return false;
      } else {
          return true;
      }
  }),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "validation.confirmPassword.mismatch")
    .required("validation.required")
    .matches(PATTERNS.PASSWORD_PATTERN, {
      message: "validation.password.minLength"
    })
    .max(32, "validation.max_length_32")
    .matches(PATTERNS.PASSWORD_UPPER, {
      message: "validation.password.uppercase"
    })
    .matches(PATTERNS.PASSWORD_LOWER, {
      message: "validation.password.lowercase"
    })
    .matches(PATTERNS.PASSWORD_NUMBER, {
      message: "validation.password.number"
    })
    .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
    .test('password', 'validation.password.spaces', (value) => {
      if (value && value.includes(' ')) {
          return false;
      } else {
          return true;
      }
  }),
  ipAddress: Yup.string()
    .required("validation.required")
    .test("subnet", "validation.subnet", (ipAddress) => {
      const subnetMask = ipAddress && ipAddress.split("/")[1];
      if (subnetMask < 24 || subnetMask > 32) {
        return false;
      } else {
        return true;
      }
    })
    .test("ipAddress", "validation.ip.invalid", (ipAddress) => {
      const ip = ipAddress && ipAddress.split("/")[0];
      return PATTERNS.IP_PATTERN.test(ip);
    }),
  email: Yup.string()
    .max(240, "validation.max_length_240")
    .required("validation.required")
    .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
    .matches(PATTERNS.EMAIL_PATTERN, {
      message: "validation.email.invalid"
    }),
  userGroupName: Yup.string()
    .required("validation.required")
    .max(64, "validation.max_length_64"),
  phone: Yup.string().trim()
    .required("validation.required")
    .test('len', 'validation.phone_number.not_only_zero', val => {
      if (val && parseInt(val) === 0) {
        return false;
      } else {
        return true;
      }
    })
    .test('len', "validation.min_length_8", val => {
      return Math.ceil(Math.log10(val)) >= 8
    }),
  postalCode: Yup.number()
    .required("validation.required")
    .test('len', "validation.max_length_10", val =>  { return Math.ceil(Math.log10(val + 1)) <= 10 })
};
